import { Component } from '@angular/core';

@Component({
   selector: 'ndt-graylog-logo',
   templateUrl: './graylog-logo.component.html',
   styleUrls: ['../logo-icon.scss'],
   standalone: false,
})
export class GraylogLogoComponent {}
